import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import * as healthSource from '../api/healthSourceApi';
import * as d from "../reducers/domainReducer";
import * as account from '../api/accountApi';
import * as provider from "../api/providerApi";
import * as portal from "../api/portalApi";
import * as Tools from "../helpers/Tools";
import { logUI, logAPI } from "../api/andyliticsApi";
import * as constants from '../constants/textConstants';

const phoneNumber = `<a href='tel:${window.serverData.data.technicalHelpDeskNumber}'>${window.serverData.data.technicalHelpDeskNumber}</a>`;
const technicalHelpDeskHours = window.serverData ? window.serverData.data.technicalHelpDeskHours : "";

export default function* healthSourceSaga() {
    yield takeLatest([types.LOAD_HEALTHSOURCEDASHBOARD_START], handleHealthSourceAction);
    yield takeLatest([types.USER_AUTHENTICATE_SUCCESS], handleHealthSourceAction);
    yield takeLatest([types.REMOVE_SLIDE], handleHealthSourceAction);
    yield takeLatest([types.LOAD_MYCHART_TERMS_DATA_START], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_INSURANCE_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_FAMILYMEMBERS_SCREEN_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_NOTIFICATIONS_SCREEN_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_SCHEDULE_CARE_TOOLTIP_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.INITIALIZE_ONBOARDING_PREFERENCES], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_CARE_COACH_MODAL_PREFERENCE], handleHealthSourceAction);

    yield takeLatest([types.UPDATE_AUTOLINK_MYCHART_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.AUTOLINK_MYCHART], handleHealthSourceAction);
    yield takeLatest([types.AUTOLINK_MYCHART_UPDATE_TOKEN_SUCCESS], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_ADD_DEPENDENT_PROXY_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_VIDEO_VISIT_TOOLTIP_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_PROXY_REQUESTEE_INFO], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_GETCARE_TOOLTIP_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_THRIVE_TOOLTIP_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_FAMILY_MANAGEMENT_TOOLTIP_PREFERENCE], handleHealthSourceAction);
    //yield takeLatest([types.UPDATE_DCJ_SELF_ENROLL_TOOLTIP_PREFERENCE], handleHealthSourceAction);
    //yield takeLatest([types.UPDATE_CARECOACH_JOURNEY_PREFERENCE], handleHealthSourceAction);
    yield takeLatest([types.UPDATE_SEEN_MARKETING_EMAIL_OPT_IN], handleHealthSourceAction);
    yield takeLatest([types.DISMISS_FLU_TILE], handleHealthSourceAction);

    yield takeLatest([types.LINK_EMPLOYEE_ACCOUNT_START], handleLinkEmployeeAccount);
    yield takeLatest([types.LINK_EMPLOYEE_ACCOUNT_SUCCESS], handleLinkEmployeeAccount);
    yield takeLatest([types.UNLINK_EMPLOYEE_ACCOUNT_START], handleUnlinkEmployeeAccount);
    yield takeLatest([types.UNLINK_EMPLOYEE_ACCOUNT_SUCCESS], handleUnlinkEmployeeAccount);

    yield takeLatest([types.LINK_MYCHART_ACCOUNT_START], handleLinkMyChartAccount);
    yield takeLatest([types.LINK_MYCHART_ACCOUNT_SUCCESS], handleLinkMyChartAccount);
    yield takeLatest([types.UNLINK_MYCHART_ACCOUNT_START], handleUnlinkMyChartAccount);
    yield takeLatest([types.UNLINK_MYCHART_ACCOUNT_SUCCESS], handleUnlinkMyChartAccount);

    yield takeLatest([types.GET_FAVORITE_PROVIDERS_START], handleGetFavoriteProviders);
    yield takeLatest([types.REMOVE_FAVORITE_PROVIDER_START], handleRemoveFavoriteProvider);

    yield takeLatest([types.ADD_FAVORITE_PROVIDER_START], handleAddFavoriteProvider);
    yield takeLatest([types.GET_USER_PHONE_NUMBER_START], handleAction);
    yield takeLatest([types.ADD_OR_UPDATE_USER_PHONE_NUMBER_START], handleAction);
    yield takeLatest([types.GET_USER_ADDRESS_START], handleAction);

    yield takeLatest([types.GET_LAT_LNG_USER_ADDRESS_START], handleAction);

    yield takeLatest([types.DISMISS_ONBOARDING_PHASEONE_TOOLTIP], handleHealthSourceAction); 
    yield takeLatest([types.DISMISS_ONBOARDING_PHASETWO_TOOLTIP], handleHealthSourceAction); 
    yield takeLatest([types.DISMISS_ONBOARDING_PHASETHREE_TOOLTIP], handleHealthSourceAction); 
    yield takeLatest([types.DISMISS_ONBOARDING_PHASEFOUR_TOOLTIP], handleHealthSourceAction); 
    yield takeLatest([types.DISMISS_LINK_MEDICALRECORD_PHASEONE_TOOLTIP], handleHealthSourceAction); 
    yield takeLatest([types.GET_RECENT_VISITED_DOCTORS_START], handleGetRecentVisitedDoctors);

    //yield takeLatest([types.GET_CARETEAM_PROVIDERS_START], handleGetCareTeam);


}

function* handleAction(data) {
    try {
        const domainData = yield select((state) => state.domain);
        switch (data.type) {
            case types.GET_USER_PHONE_NUMBER_START:
                try {
                    let response = yield call(account.getUserPhoneNumber, domainData.t, data.userName);
                    if (response) {
                        yield put({ type: types.GET_USER_PHONE_NUMBER_SUCCESS, getUserPhoneNumberResponse: response, getUserPhoneNumberErrorText: null });
                    }
                    else {
                        yield put({ type: types.GET_USER_PHONE_NUMBER_FAILURE, getUserPhoneNumberErrorText: "We are unable to display your phone number" });
                    }
                }
                catch (getUserPhoneError) {
                    if (getUserPhoneError && getUserPhoneError.status && getUserPhoneError.status === 404) {
                        yield put({ type: types.GET_USER_PHONE_NUMBER_SUCCESS, getUserPhoneNumberResponse: "None entered", getUserPhoneNumberErrorText: null });
                    }
                    else {
                        yield put({ type: types.GET_USER_PHONE_NUMBER_FAILURE, getUserPhoneNumberErrorText: "We are unable to display your phone number" });
                    }
                }
                break;

            case types.ADD_OR_UPDATE_USER_PHONE_NUMBER_START:
                try {
                    let response = yield call(account.addOrUpdateUserPhoneNumber, domainData.t, data.userName, data.AreaCode, data.PhoneNumber, data.userId, data.newUser);
                    yield put({ type: types.ADD_OR_UPDATE_USER_PHONE_NUMBER_SUCCESS, addUpdateUserPhoneNumberSuccessText: "Your phone number has been updated." });
                }
                catch (addUpdateUserPhoneError) {
                    if (addUpdateUserPhoneError && addUpdateUserPhoneError.status && addUpdateUserPhoneError.status === 404) {
                        yield put({ type: types.ADD_OR_UPDATE_USER_PHONE_NUMBER_FAILURE, addUpdateUserPhoneNumberErrorText: "Error while updating phone number. Please try again later" });
                    }
                    else {
                        yield put({ type: types.ADD_OR_UPDATE_USER_PHONE_NUMBER_FAILURE, addUpdateUserPhoneNumberErrorText: "Error while updating phone number. Please try again later" });
                    }
                }
                break;

            case types.GET_USER_ADDRESS_START:
                try {
                    let response = yield call(account.getUserAddresses, domainData.t, data.userName);
                    yield put({ type: types.GET_USER_ADDRESS_SUCCESS, getUserAddressResponse: response });
                }
                catch (exception) {
                    yield put({ type: types.GET_USER_ADDRESS_FAILURE, getUserAddressResponse: null });
                }
                break;

            case types.GET_LAT_LNG_USER_ADDRESS_START:
                try {
                    let response = yield call(portal.getLatLongFromAddress, domainData.t, data.address);
                    yield put({ type: types.GET_LAT_LNG_USER_ADDRESS_SUCCESS, getLatLongResponse: response });
                }
                catch (exception) {
                    yield put({ type: types.GET_LAT_LNG_USER_ADDRESS_FAILURE, getLatLongResponse: null });
                }
                break;
        }
    }
    catch (error) {
        console.error(error);
    }
}


function* syncProviderDetailLists(arrayFavoriteNPIs, arrayCareTeamNPIs) {
    const start = new Date();
    try {
        // First... update the NPI lists
        const localCacheData = yield select((state) => state.localCache);
        const healthSourceData = yield select((state) => state.healthSource);
        const domainData = yield select((state) => state.domain);
        arrayFavoriteNPIs = arrayFavoriteNPIs || healthSourceData.arrayFavoriteNPIs || [];
        arrayCareTeamNPIs = arrayCareTeamNPIs || healthSourceData.arrayCareTeamNPIs || [];

        yield put({ type: types.SET_PROVIDER_DETAILS_NPI_LISTS, arrayFavoriteNPIs: arrayFavoriteNPIs, arrayCareTeamNPIs: arrayCareTeamNPIs }); // we write these down for easily modifying later

        // Then... load any new provider details
        let oNPIArray = Tools.mergeArrays(arrayFavoriteNPIs, arrayCareTeamNPIs);
        let oProviderDetailList = localCacheData.ProviderDetailList || [];
        let oNPIsToLoad = Tools.getUnhydratedProviderNPIs(oNPIArray, oProviderDetailList);
        if (oNPIsToLoad.length > 0) {
            let oNewDetailList = [];
            oNewDetailList = yield call(provider.getProviderDetailLiteV2, domainData.t, oNPIsToLoad.join("|"), domainData.nc, true);
            //debugger;
            oProviderDetailList = oProviderDetailList.concat(oNewDetailList);
            yield put({ type: types.SET_PROVIDER_DETAILS_FROM_NPI_LIST, arrayProviders: oProviderDetailList }); // we write these down for easily modifying later
        }

        // Then... parse the details back into separate arrays
        //debugger;
        let oFavoriteProviders = oProviderDetailList.filter(function (provider) { return arrayFavoriteNPIs.indexOf(provider.npi) > -1; });
        let oCareTeamProviders = oProviderDetailList.filter(function (provider) { return arrayCareTeamNPIs.indexOf(provider.npi) > -1 && arrayFavoriteNPIs.indexOf(provider.npi) < 0; });
        //debugger;
        yield put({ type: types.SET_PARSED_PROVIDER_DETAILS_LISTS, arrayFavorites: oFavoriteProviders, arrayCareTeam: oCareTeamProviders }); // we write these down for easily modifying later

    }
    catch (wasAGoodTry) {
        console.error(wasAGoodTry);
        logAPI("MBHWeb.Saga.HealthSource.SyncProviderDetails.Failure", start, null, wasAGoodTry);
        //logUI("syncProviderDetails.Err", wasAGoodTry);
    }


}

function* handleGetFavoriteProviders(data) {
    const start = new Date();
    try {
        const domainData = yield select((state) => state.domain);
        switch (data.type) {
            case types.GET_FAVORITE_PROVIDERS_START:

                // Get both lists simultaneously
                let oResultFavs = [];
                let oResultCareTeam = [];
                if (domainData && domainData.cu && domainData.cu.eid) {
                    [oResultFavs, oResultCareTeam] = yield all([
                        call(healthSource.getProviderFavorites, domainData.un, domainData.t),
                        call(healthSource.getCareTeam, domainData.t, domainData.un, domainData.cu.eid)
                    ]);
                }
                else {
                    oResultFavs = yield call(healthSource.getProviderFavorites, domainData.un, domainData.t);
                }

                // Get Favs
                //let oResultFavs = yield call(healthSource.getProviderFavorites, domainData.un, domainData.t);
                // Get Care Team
                //let oResultCareTeam = yield call(healthSource.getCareTeam, domainData.t, domainData.un, domainData.eid);
                //debugger;
                yield syncProviderDetailLists(oResultFavs, oResultCareTeam);

                yield put({ type: types.GET_FAVORITE_PROVIDERS_SUCCESS });
                yield put({ type: types.GET_CARETEAM_PROVIDERS_SUCCESS });

                break;

        }
    }
    catch (exception) {
        //debugger;
        //logUI("getFavorites.Err", exception);
        logAPI("MBHWeb.Saga.HealthSource.GetFavorites.Failure", start, null, exception);
        yield put({ type: types.SET_PROVIDER_DETAILS_NPI_LISTS, arrayFavoriteNPIs: null, arrayCareTeamNPIs: null }); // clear these out in event of failure
        yield put({ type: types.SET_PARSED_PROVIDER_DETAILS_LISTS, arrayFavorites: null, arrayCareTeam: null }); // clear these out in event of failure
        yield put({ type: types.GET_FAVORITE_PROVIDERS_FAILURE, errorText: exception && exception.message ? exception.message : "Failed to load favorite providers." });
        yield put({ type: types.GET_CARETEAM_PROVIDERS_FAILURE, errorText: exception && exception.message ? exception.message : "Failed to load careteam providers." });
        console.error(exception);
    }
}


function* handleGetRecentVisitedDoctors(data) {
    const start = new Date();
    try {
        const domainData = yield select((state) => state.domain);
        const recentVisitedDoctors = yield Tools.safeCall(healthSource.getRecentVisitedDoctors, domainData.t);
        if (recentVisitedDoctors && recentVisitedDoctors.err) {
            yield put({ type: types.GET_RECENT_VISITED_DOCTORS_FAILURE });
            logAPI("MBHWeb.Saga.HealthSource.GetRecentVisitedDoctors.Failure", start, null, recentVisitedDoctors);
        } else {
            let response = recentVisitedDoctors && recentVisitedDoctors.result ? recentVisitedDoctors.result : null;
            yield put({ type: types.GET_RECENT_VISITED_DOCTORS_SUCCESS, recentVisitedDoctors: response });
            logAPI("MBHWeb.Saga.HealthSource.GetRecentVisitedDoctors.Success", start, null, recentVisitedDoctors);
        }
    }
    catch (exception) {
        yield put({ type: types.GET_RECENT_VISITED_DOCTORS_FAILURE });
        logAPI("MBHWeb.Saga.HealthSource.GetRecentVisitedDoctors.Failure", start, null, exception);
        console.error(exception);
    }
}

function* handleAddFavoriteProvider(data) {
    const { completionCallback } = data;
    try {
        const domainData = yield select((state) => state.domain);
        const healthSourceData = yield select((state) => state.healthSource);
        switch (data.type) {
            case types.ADD_FAVORITE_PROVIDER_START:

                let oResult = yield call(healthSource.addProviderToFavorites, domainData.t, domainData.un, data.npi);

                //debugger;
                if (oResult.UserProvider && oResult.UserProvider.IsFavorited) {
                    yield syncProviderDetailLists(healthSourceData.arrayFavoriteNPIs.concat(data.npi), null);

                    //let oNew = yield call(provider.getProviderDetailV1, domainData.t, data.npi, domainData.nc, true);
                    //yield handleGetFavoriteProviders({ type: types.GET_FAVORITE_PROVIDERS_START });  // shortcut to refetch the list synchronously
                    yield put({ type: types.ADD_FAVORITE_PROVIDER_SUCCESS, npi: data.npi });
                }
                else {
                    yield put({ type: types.ADD_FAVORITE_PROVIDER_FAILURE, npi: data.npi });
                }

                if (completionCallback) {
                    completionCallback();
                }
                break;

        }
    }
    catch (exception) {
        //debugger;
        yield put({ type: types.ADD_FAVORITE_PROVIDER_FAILURE, errorText: exception && exception.message ? exception.message : "Failed to add to favorite providers." });
        console.error(exception);
        if (completionCallback) {
            completionCallback();
        }
    }
}


function* handleRemoveFavoriteProvider(data) {
    const { completionCallback } = data;
    try {
        const domainData = yield select((state) => state.domain);
        const healthSourceData = yield select((state) => state.healthSource);
        switch (data.type) {
            case types.REMOVE_FAVORITE_PROVIDER_START:
                let oResult = yield call(healthSource.removeProviderFromFavorites, domainData.t, domainData.un, data.npi);
                //debugger;
                if (oResult.IsHidden || !oResult.IsFavorited) {
                    yield syncProviderDetailLists(healthSourceData.arrayFavoriteNPIs.filter(function (npi) { return npi !== data.npi; }), null);
                    yield put({ type: types.REMOVE_FAVORITE_PROVIDER_SUCCESS, npi: data.npi });
                }
                else {
                    yield put({ type: types.REMOVE_FAVORITE_PROVIDER_FAILURE, npi: data.npi });
                }

                if (completionCallback) {
                    completionCallback();
                }
                break;

        }
    }
    catch (exception) {
        //debugger;
        yield put({ type: types.REMOVE_FAVORITE_PROVIDER_FAILURE, errorText: exception && exception.message ? exception.message : "Failed to remove favorite provider." });
        console.error(exception);
        if (completionCallback) {
            completionCallback();
        }
    }
}



function* handleLinkEmployeeAccount(data) {
    try {
        const domainData = yield select((state) => state.domain);
        switch (data.type) {
            case types.LINK_EMPLOYEE_ACCOUNT_START:
                //debugger;
                let oResult = yield call(account.linkEmployeeAccount, domainData.t, data.lanId, data.password, true, domainData.un);
                //debugger;
                if (oResult.isSuccessful) {
                    yield put({ type: types.LINK_EMPLOYEE_ACCOUNT_SUCCESS, successText: oResult.responseMessage, isStandalone: data.isFromMobile ? true : false });
                }
                else {
                    yield put({ type: types.LINK_EMPLOYEE_ACCOUNT_FAILURE, errorText: oResult.responseMessage });
                }
                //debugger;
                break;
            case types.LINK_EMPLOYEE_ACCOUNT_SUCCESS:
                //debugger;
                yield put({ type: types.REFRESH_TOKEN });
                if (!data.isStandalone) {
                    window.setTimeout(() => {
                        window.store.dispatch({ type: types.LINK_EMPLOYEE_CLEAR_MESSAGE });
                    }, 10000);
                }
                break;
        }
    }
    catch (exception) {
        console.error(exception);

        // not sure how I want to record these yet
        //debugger;
        yield put({ type: types.LINK_EMPLOYEE_ACCOUNT_FAILURE, errorText: exception && exception.message ? exception.message : "Failed to link employee account." });
    }
}


function* handleUnlinkEmployeeAccount(data) {
    try {
        const domainData = yield select((state) => state.domain);
        switch (data.type) {
            case types.UNLINK_EMPLOYEE_ACCOUNT_START:
                //debugger;
                let oResult = yield call(account.unlinkEmployeeAccount, domainData.t, true, domainData.un);
                //debugger;
                if (oResult.isSuccessful) {
                    yield put({ type: types.UNLINK_EMPLOYEE_ACCOUNT_SUCCESS, successText: oResult.responseMessage, isStandalone: data.isFromMobile ? true : false });
                }
                else {
                    yield put({ type: types.UNLINK_EMPLOYEE_ACCOUNT_FAILURE, errorText: oResult.responseMessage });
                }
                //debugger;
                break;
            case types.UNLINK_EMPLOYEE_ACCOUNT_SUCCESS:
                //debugger;
                yield put({ type: types.REFRESH_TOKEN }); // this picks up the refresh token from domain now
                if (!data.isStandalone) {
                    window.setTimeout(() => {
                        window.store.dispatch({ type: types.UNLINK_EMPLOYEE_CLEAR_MESSAGE });
                    }, 10000);
                }

                break;

        }
    }
    catch (exception) {
        console.error(exception);

        // not sure how I want to record these yet
        //debugger;
        yield put({ type: types.UNLINK_EMPLOYEE_ACCOUNT_FAILURE, errorText: exception && exception.message ? exception.message : "Failed to unlink employee account." });
    }
}


function* handleLinkMyChartAccount(data) {
    const stateData = yield select((state) => state.common);

    if (stateData && stateData.epicEHRDown === false) {
        try {
            const domainData = yield select((state) => state.domain);
            switch (data.type) {
                case types.LINK_MYCHART_ACCOUNT_START:
                    //debugger;                
                    let oResult = yield call(account.linkMyChartAccount, domainData.t, data.MyChartUserName, data.MyChartPassword, domainData.hm, domainData.un);
                    //debugger;
                    if (oResult.isSuccessful) {
                        yield put({ type: types.LINK_MYCHART_ACCOUNT_SUCCESS, successText: oResult.responseMessage, isStandalone: data.isFromMobile ? true : false });
                    }
                    else {
                        yield put({ type: types.LINK_MYCHART_ACCOUNT_FAILURE, errorText: oResult.responseMessage });
                    }
                    //debugger;
                    break;
                case types.LINK_MYCHART_ACCOUNT_SUCCESS:
                    //debugger;
                    //Moving from ssosaga to here.
                    yield put({
                        type: types.RESET_USER_VALUE
                    });
                    yield put({ type: types.REFRESH_TOKEN });
                    if (!data.isStandalone) {
                        window.setTimeout(() => {
                            window.store.dispatch({ type: types.LINK_MYCHART_CLEAR_MESSAGE });
                        }, 10000);
                    }
                    break;
            }
        }
        catch (exception) {
            console.error(exception);

            // not sure how I want to record these yet
            //debugger;
            yield put({ type: types.LINK_MYCHART_ACCOUNT_FAILURE, errorText: exception && exception.message ? exception.message : "Failed to link mychart account." });
        }
    }
    else {
        console.log("healthSourceSaga: epicEHRDown");
    }
}


function* handleUnlinkMyChartAccount(data) {
    const stateData = yield select((state) => state.common);

    if (stateData && stateData.epicEHRDown === false) {
        try {
            const domainData = yield select((state) => state.domain);
            switch (data.type) {
                case types.UNLINK_MYCHART_ACCOUNT_START:
                    //debugger;
                    let oResult = yield call(account.unlinkMyChartAccount, domainData.t, domainData.hm, domainData.un);
                    //debugger;
                    if (oResult.isSuccessful) {
                        yield put({ type: types.UNLINK_MYCHART_ACCOUNT_SUCCESS, successText: oResult.responseMessage, isStandalone: data.isFromMobile ? true : false });
                    }
                    else {
                        yield put({ type: types.UNLINK_MYCHART_ACCOUNT_FAILURE, errorText: oResult.responseMessage });
                    }
                    //debugger;
                    break;
                case types.UNLINK_MYCHART_ACCOUNT_SUCCESS:
                    //debugger;
                    //Moving from ssosaga to here.
                    yield put({
                        type: types.RESET_USER_VALUE
                    });
                    yield put({ type: types.REFRESH_TOKEN }); // this picks up the refresh token from domain now
                    if (!data.isStandalone) {
                        window.setTimeout(() => {
                            window.store.dispatch({ type: types.UNLINK_MYCHART_CLEAR_MESSAGE });
                        }, 10000);
                    }

                    break;

            }
        }
        catch (exception) {
            console.error(exception);

            // not sure how I want to record these yet
            //debugger;
            yield put({ type: types.UNLINK_MYCHART_ACCOUNT_FAILURE, errorText: exception && exception.message ? exception.message : "Failed to unlink mychart account." });
        }
    }
    else {
        console.log("healthSourceSaga: epicEHRDown");
    }
}

function* handleHealthSourceAction(data) {
    const start = new Date();
    try {
        const domainData = yield select((state) => state.domain);
        let userAge = domainData.pu?.ay || domainData.age;
        let isUserMinor = userAge && userAge < 18;
        let hasMyChart = domainData.hm;

        //Below calls required user token expect autolink mychart update token.
        if (domainData && (domainData.t || (data && data.type && data.type === types.AUTOLINK_MYCHART_UPDATE_TOKEN_SUCCESS))) {
            switch (data.type) {
                //case types.USER_AUTHENTICATE_SUCCESS:
                case types.LOAD_HEALTHSOURCEDASHBOARD_START:
                    const response = yield call(healthSource.getUserTilesByClientData, domainData.t);
                    yield put({ type: types.LOAD_HEALTHSOURCEDASHBOARD_SUCCESS, healthSourceDashboardData: response, isWaiting: false });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.Get", start, null, data);
                    break;
                case types.REMOVE_SLIDE:
                    const removeResponse = yield call(healthSource.removeSlideTile, data.tileId, domainData.t);
                    if (removeResponse) {
                        const refreshresponse = yield call(healthSource.getUserTilesByClientData, domainData.t);
                        yield put({ type: types.LOAD_HEALTHSOURCEDASHBOARD_SUCCESS, healthSourceDashboardData: refreshresponse, isWaiting: false });
                    }
                    break;
                case types.UPDATE_INSURANCE_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "ShowCaptureInsuranceForm", false);
                    yield put({
                        type: types.SHOW_INSURANCE_FORM, showInsuranceForm: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetInsurancePreference", start, null, data);
                    break;
                case types.UPDATE_ADD_DEPENDENT_PROXY_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "DontPromptToAddProxies", true);
                    yield put({
                        type: types.SHOW_ADD_DEPENDENT_PROXY_FORM, showDependentProxyForm: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetAddDependentProxyPreference", start, null, data);
                    break;
                case types.UPDATE_AUTOLINK_MYCHART_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "DeclinedMyChart", true);
                    yield put({
                        type: types.SHOW_AUTOLINK_MYCHART, showAutoLinkMyChart: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetMyChartPreference", start, null, data);
                    break;
                case types.UPDATE_VIDEO_VISIT_TOOLTIP_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "HideVideoVisitToolTipForWeb", true);
                    yield put({
                        type: types.SHOW_VIDEO_VISIT_TOOLTIP, showVideoVisitToolTip: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetVideoVisitToolTipPreference", start, null, data);
                    break;
                case types.UPDATE_PROXY_REQUESTEE_INFO:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "MapProxyRequesteeInfo", null);
                    yield put({
                        type: types.SAVE_PROXY_REQUESTEE_INFO, proxyRequesteeInfo: null
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetProxyRequesteePreference", start, null, data);
                    break;
                case types.UPDATE_GETCARE_TOOLTIP_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, constants.HideGetCareToolTip, true);
                    yield put({
                        type: types.SHOW_GET_CARE_TOOLTIP, showGetCareToolTip: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetGetCareToolTipPreference", start, null, data);
                    break;
                case types.UPDATE_FAMILY_MANAGEMENT_TOOLTIP_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, constants.ShowFamilyManagementToolTip, false);
                    yield put({
                        type: types.SHOW_FAMILY_MANAGEMENT_TOOLTIP, showFamilyManagementToolTip: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetHideFamilyManagementToolTipPreference", start, null, data);
                    break;
                case types.UPDATE_THRIVE_TOOLTIP_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, constants.ShowThriveTooltip, false);
                    yield put({
                        type: types.SHOW_THRIVE_TOOLTIP, showThriveTooltip: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetHideThriveTooltipPreference", start, null, data);
                    break;
                //case types.UPDATE_DCJ_SELF_ENROLL_TOOLTIP_PREFERENCE:
                //    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "HideDCJSelfEnrollToolTip", true);
                //    yield put({
                //        type: types.SHOW_DCJ_SELF_ENROLL_TOOLTIP, showDCJSelfEnrollToolTip: false
                //    });
                //    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetDCJSelfEnrollToolTipPreference", start, null, data);
                //    break;
                //case types.UPDATE_CARECOACH_JOURNEY_PREFERENCE:
                //    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "WebDePrioritizeDCJEIds", data.noActiveDCJEids);
                //    yield put({
                //        type: types.CARECOACH_JOURNEY_PREFERENCE, noActiveDCJEids: data.noActiveDCJEids
                //    });
                //    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetWebDePrioritizeDCJEIdsPreference", start, null, data);
                //    break;
                case types.UPDATE_SEEN_MARKETING_EMAIL_OPT_IN:
                    const updateMarketingEmailOptIn = yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "HasSeenEmailOptIn", true);
                    yield put({
                        type: types.SHOW_MARKETING_EMAIL_OPT_IN, showEmailOptIn: false
                    });
                    if (updateMarketingEmailOptIn && updateMarketingEmailOptIn.result && updateMarketingEmailOptIn.result.isSuccessful) {
                        logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetWebHasSeenEmailOptIn", start, null, updateMarketingEmailOptIn);
                    } else {
                        logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetWebHasSeenEmailOptIn.Failure", start, null, updateMarketingEmailOptIn);
                    }
                    break;
                case types.UPDATE_FAMILYMEMBERS_SCREEN_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, 'ShowFamilyMembersScreen', false);
                    yield put({
                        type: types.SHOW_FAMILYMEMBERS_SCREEN, showFamilyMembersScreen: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetShowFamilyMembersScreenPreference", start, null, data);
                    break;
                //case types.UPDATE_CARE_COACH_MODAL_PREFERENCE:
                //    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, 'ShowCareCoachModal', false);
                //    yield put({
                //        type: types.SHOW_CARE_COACH_MODAL, showCareCoachModal: false
                //    });
                //    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetShowCareCoachModalPreference", start, null, data);
                //    break;
                case types.UPDATE_NOTIFICATIONS_SCREEN_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, 'ShowNotificationsScreen', false);
                    yield put({
                        type: types.SHOW_NOTIFICATIONS_SCREEN, showNotificationsScreen: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetShowNotificationsScreenPreference", start, null, data);
                    break;
                case types.UPDATE_SCHEDULE_CARE_TOOLTIP_PREFERENCE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, 'ShowScheduleCareTooltip', false);
                    yield put({
                        type: types.SHOW_SCHEDULE_CARE_TOOLTIP, showScheduleCareTooltip: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetShowScheduleCareTooltipPreference", start, null, data);
                    break;
                case types.INITIALIZE_ONBOARDING_PREFERENCES:
                    if (!isUserMinor && hasMyChart)
                    {
                        yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "ShowCaptureInsuranceForm", true);
                        yield Tools.safeCall(account.resetUserPreferences2, domainData.t, 'ShowFamilyMembersScreen', true);
                    }
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, 'ShowNotificationsScreen', true);                   
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, 'ShowScheduleCareTooltip', true);                   
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetShowScheduleCareTooltipPreference", start, null, data);
                    break;
                case types.DISMISS_FLU_TILE:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "HideFluTile2021", true);
                    yield put({
                        type: types.HIDE_FLU_VACCINE_TILE, hideFluVaccineTile: true
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetWebHideFluTile2021Preference", start, null, data);
                    break;
                case types.DISMISS_ONBOARDING_PHASEONE_TOOLTIP:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "ShowOnBoardingPhaseOneToolTipWeb", false);
                    yield put({
                        type: types.SHOW_ONBOARDING_PHASEONE_TOOLTIP, showOnBoardingPhaseOneToolTipWeb: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetOnBoardingPhaseOneToolTipWeb", start, null, data);
                    break;
                case types.DISMISS_ONBOARDING_PHASETWO_TOOLTIP:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "ShowOnBoardingPhaseTwoToolTipWeb", false);
                    yield put({
                        type: types.SHOW_ONBOARDING_PHASETWO_TOOLTIP, showOnBoardingPhaseTwoToolTipWeb: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetOnBoardingPhaseTwoToolTipWeb", start, null, data);
                    break;
                case types.DISMISS_ONBOARDING_PHASETHREE_TOOLTIP:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "ShowOnBoardingPhaseThreeToolTipWeb", false);
                    yield put({
                        type: types.SHOW_ONBOARDING_PHASETHREE_TOOLTIP, showOnBoardingPhaseThreeToolTipWeb: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetOnBoardingPhaseThreeToolTipWeb", start, null, data);
                    break;
                case types.DISMISS_ONBOARDING_PHASEFOUR_TOOLTIP:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "ShowOnBoardingPhaseFourToolTipWeb", false);
                    yield put({
                        type: types.SHOW_ONBOARDING_PHASEFOUR_TOOLTIP, showOnBoardingPhaseFourToolTipWeb: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetOnBoardingPhaseFourToolTipWeb", start, null, data);
                    break;
                case types.DISMISS_LINK_MEDICALRECORD_PHASEONE_TOOLTIP:
                    yield Tools.safeCall(account.resetUserPreferences2, domainData.t, "ShowLinkMedicalRecord", false);
                    yield put({
                        type: types.SHOW_LINK_MEDICALRECORD_PHASEONE_TOOLTIP, showLinkMedicalRecordPhaseOneToolTip: false
                    });
                    logAPI("MBHWeb.Saga.HealthSourceDashboard.ResetLinkMedicalRecordPhaseOneToolTip", start, null, data);
                    break;
                case types.AUTOLINK_MYCHART:
                    if (domainData && domainData.t) {
                        try {
                            const response = yield call(healthSource.autolinkMyChart, domainData.t, domainData.un, data.dob);
                            if (response && response.status === 200) {
                                yield put({ type: types.AUTOLINK_MYCHART_UPDATE_TOKEN_SUCCESS });
                                logAPI("MBHWeb.Saga.AutoLink.MyChart.Success", start, null);
                            }
                            else if (response && response.Errors && response.Errors.length > 0) {
                                const error = getLinkError(response.Errors[0]);
                                yield put({ type: types.AUTOLINK_MYCHART_FAILURE, autolinkMyChartSuccess: null, isAutoLinkMyChartWaiting: false, autolinkMyChartFailure: error || "We were unable to link your account." });
                                if (response.Errors[0] && response.Errors[0].Code && response.Errors[0].Code === 'patient_not_found') {
                                    yield put({ type: types.AUTOLINK_MYCHART_ERROR_COUNT });
                                } else {
                                    yield put({ type: types.AUTOLINK_MYCHART_ERROR_COUNT, payload: { countOfLinkMyChartError: 3 } });
                                }
                                logAPI("MBHWeb.Saga.AutoLink.MyChart.Failure", start, null, response.Errors);
                            }
                        }
                        catch (err) {
                            logAPI("MBHWeb.Saga.AutoLink.MyChart.Failure", start, null, err);
                        }
                    }
                    break;
                case types.AUTOLINK_MYCHART_UPDATE_TOKEN_SUCCESS:
                    try {
                        logAPI("MBHWeb.Saga.AutoLink.MyChart.Tokenupdate", start, null);
                        yield put({ type: types.REFRESH_TOKEN });
                        yield put({ type: types.AUTOLINK_MYCHART_SUCCESS, autolinkMyChartSuccess: "We have successfully linked your account.", isAutoLinkMyChartWaiting: false });
                    } catch (error) {
                        logAPI("MBHWeb.Saga.AutoLink.MyChart.Tokenupdate.Error", start, null, error1);
                    }
                    break;
                //case types.LOAD_MYCHART_TERMS_DATA_START:
                //    try {
                //        const response = yield call(healthSource.myChartTerms, domainData.t, domainData.un);                       
                //        if (response && response.exceptionMessage === null) {                           
                //            yield put({ type: types.LOAD_MYCHART_TERMS_DATA_SUCCESS, successText: response.textToDisplay, errorText: null, myChartTermsInProcess:false });
                //        }
                //        else {
                //            yield put({ type: types.LOAD_MYCHART_TERMS_DATA_FAILURE, errorText: response.exceptionMessage, successText: null, myChartTermsInProcess:false });
                //        }

                //    }
                //    catch (loadMyChartTermsError) {
                //        if (loadMyChartTermsError && loadMyChartTermsError.status && (loadMyChartTermsError.status === 404 || loadMyChartTermsError.status === 400)) {
                //            yield put({ type: types.LOAD_MYCHART_TERMS_DATA_FAILURE, errorText: loadMyChartTermsError.statusText, myChartTermsInProcess: false });
                //        }
                //    }
                //    break;

            }
        }

    }
    catch (response) {
        console.error(response);
        logAPI("MBHWeb.Saga.HealthSourceDashboard.Get.Failure", start, null, response);
        if (response && response.status && response.status === 401) {
            yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
        }
        else {
            yield put({ type: types.AJAX_CALL_ERROR, healthSourceError: response });
        }
    }
}

function getLinkError(error) {

    const helpDeskMessage = `For technical assistance, call the MyBSWHealth technical help desk ${technicalHelpDeskHours} at ${phoneNumber}.`;
    if (error && error.Code) {
        switch (error.Code) {
            case "patient_not_found":
                return `The date of birth doesn't match what is on file.`;
            case "multiple_records_match":
                return `We could not find that account. ` + helpDeskMessage;
            case "username_not_found":
                return `${error.DisplayMessage}. ` + helpDeskMessage;
            case "memberid_not_found":
            case "member_not_found":
                return `The member ID was not found. ` + helpDeskMessage;
            case "account_linking_failed":
            case "unhandled_exception":
                return `We were unable to link your account. ` + helpDeskMessage;
            case "login_already_exists":
                return `You may have duplicate accounts. ` + helpDeskMessage;
            default:
                return `We were unable to link your account. ` + helpDeskMessage;
        }
    }
}